import * as React from "react";
import type { SVGProps } from "react";
const SvgSwap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#swap_svg__a)">
      <path d="M12 21H9c-2.21 0-4-1.79-4-4V6.41L3.71 7.7a.996.996 0 0 1-1.41 0 .996.996 0 0 1-.01-1.41l3-3c.1-.1.21-.17.33-.22s.24-.08.38-.08c.13 0 .26.03.38.08s.23.12.33.22l3 3A.996.996 0 1 1 8.3 7.7L7.01 6.41V17c0 1.1.9 2 2 2h3c.55 0 1 .45 1 1s-.45 1-1 1zM18 21c-.13 0-.26-.03-.38-.08s-.23-.12-.33-.22l-3-3a.996.996 0 1 1 1.41-1.41l1.29 1.29V7c0-1.1-.9-2-2-2h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c2.21 0 4 1.79 4 4v10.59l1.29-1.29a.996.996 0 1 1 1.41 1.41l-3 3c-.1.1-.21.17-.33.22s-.24.08-.38.08z" />
    </g>
    <defs>
      <clipPath id="swap_svg__a">
        <path fill="#fff" d="M2 3h20v18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSwap;
